module.exports = __webpack_public_path__ + "img/bank-card-eg.96e29594.jpg";